module.exports = __webpack_public_path__ + "static/media/SMS.517bfe6b.png";